import { managerFactory } from "@/factories/manager";
import { initializeLoggerClient } from "@/manager/logging-client/initializeLoggerClient";

export const loggerClientManager = managerFactory.create({
  initializer: initializeLoggerClient,
});
